'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type FC, type ReactNode, useEffect, useState } from 'react';
import { cn } from '@/libs/utils';
interface TimerProps {
  time: Date;
  textPosition?: 'left' | 'right';
  textMobilePosition?: 'bottom' | 'top';
  className?: string;
  text?: ReactNode;
  showDays?: boolean;
  variant?: 'default' | 'alternative';
  withoutMd?: boolean;
}
const TimerDigit: FC<{
  value: number;
  withoutMd?: boolean;
}> = t0 => {
  const $ = _c(23);
  const {
    value,
    withoutMd: t1
  } = t0;
  const withoutMd = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== value) {
    t2 = value.toString().padStart(2, "0");
    $[0] = value;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const formattedValue = t2;
  const t3 = `relative overflow-clip rounded-[3px] bg-[rgba(255,255,255,0.2)] ${!withoutMd ? "h-8 w-6 md:h-12 md:w-8" : "h-12 w-8"}`;
  const t4 = `absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center bg-gradient-to-b from-[#ffffff1a] via-[#ffffff1a] via-50% to-[#ffffff00] to-50% ${!withoutMd ? "h-8 w-6 md:h-12 md:w-8" : "h-12 w-8"}`;
  const t5 = `font-['Inter'] font-medium leading-[1.5] text-[#e9ecf0] ${!withoutMd ? "text-[24px] md:text-[36px]" : "text-[36px]"}`;
  let t6;
  if ($[2] !== formattedValue[0] || $[3] !== t5) {
    t6 = <span className={t5}>{formattedValue[0]}</span>;
    $[2] = formattedValue[0];
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4 || $[6] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[5] = t4;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t3 || $[9] !== t7) {
    t8 = <div className={t3}>{t7}</div>;
    $[8] = t3;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `relative overflow-clip rounded-[3px] bg-[rgba(255,255,255,0.2)] ${!withoutMd ? "h-8 w-6 md:h-12 md:w-8" : "h-12 w-8"}`;
  const t10 = `absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center bg-gradient-to-b from-[#ffffff1a] via-[#ffffff1a] via-50% to-[#ffffff00] to-50% ${!withoutMd ? "h-8 w-6 md:h-12 md:w-8" : "h-12 w-8"}`;
  const t11 = `font-['Inter'] font-medium leading-[1.5] text-[#e9ecf0] ${!withoutMd ? "text-[24px] md:text-[36px]" : "text-[36px]"}`;
  let t12;
  if ($[11] !== formattedValue[1] || $[12] !== t11) {
    t12 = <span className={t11}>{formattedValue[1]}</span>;
    $[11] = formattedValue[1];
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t10 || $[15] !== t12) {
    t13 = <div className={t10}>{t12}</div>;
    $[14] = t10;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13 || $[18] !== t9) {
    t14 = <div className={t9}>{t13}</div>;
    $[17] = t13;
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14 || $[21] !== t8) {
    t15 = <div className="flex gap-0.5">{t8}{t14}</div>;
    $[20] = t14;
    $[21] = t8;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
};
const TimerDigitSecond: FC<{
  value: number;
}> = t0 => {
  const $ = _c(5);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = value.toString().padStart(2, "0");
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedValue = t1;
  let t2;
  if ($[2] !== formattedValue[0] || $[3] !== formattedValue[1]) {
    t2 = <div className="flex h-8 w-8 items-center justify-center gap-0.5 rounded-[8px] bg-[rgba(255,255,255,0.2)] p-2 md:h-11 md:w-11 "><span className="font-['Montserrat'] text-[16px] font-medium text-[#e9ecf0] md:text-[24px]">{formattedValue[0]}{formattedValue[1]}</span></div>;
    $[2] = formattedValue[0];
    $[3] = formattedValue[1];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const TimerSeparator: FC<{
  withoutMd?: boolean;
}> = t0 => {
  const $ = _c(5);
  const {
    withoutMd: t1
  } = t0;
  const withoutMd = t1 === undefined ? false : t1;
  const t2 = `flex w-full items-center justify-center ${!withoutMd ? "h-8 md:h-12" : "h-12"}`;
  const t3 = `font-['Inter'] font-medium text-[#e9ecf0] ${!withoutMd ? "text-[16px] md:text-[24px]" : "text-[24px]"}`;
  let t4;
  if ($[0] !== t3) {
    t4 = <span className={t3}>:</span>;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2 || $[3] !== t4) {
    t5 = <div className="flex w-[7px] flex-col items-center justify-center pb-[5px] pt-0"><div className={t2}>{t4}</div></div>;
    $[2] = t2;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
};
export const Timer: FC<TimerProps> = t0 => {
  const $ = _c(44);
  const {
    className,
    time,
    textPosition: t1,
    textMobilePosition: t2,
    text,
    showDays: t3,
    variant: t4,
    withoutMd: t5
  } = t0;
  const textPosition = t1 === undefined ? "left" : t1;
  const textMobilePosition = t2 === undefined ? "bottom" : t2;
  const showDays = t3 === undefined ? false : t3;
  const variant = t4 === undefined ? "default" : t4;
  const withoutMd = t5 === undefined ? false : t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      hours: 0,
      minutes: 0,
      seconds: 0,
      days: 0
    };
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  const [timeLeft, setTimeLeft] = useState(t6);
  let t7;
  let t8;
  if ($[1] !== time) {
    t7 = () => {
      const calculateTimeLeft = () => {
        const difference = time.getTime() - new Date().getTime();
        if (difference <= 0) {
          return {
            hours: 0,
            minutes: 0,
            seconds: 0,
            days: 0
          };
        }
        return {
          days: Math.floor(difference / 86400000),
          hours: Math.floor(difference / 3600000 % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        };
      };
      setTimeLeft(calculateTimeLeft());
      const timer = setInterval(() => {
        const newTimeLeft = calculateTimeLeft();
        setTimeLeft(newTimeLeft);
        if (newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
          clearInterval(timer);
        }
      }, 1000);
      return () => clearInterval(timer);
    };
    t8 = [time];
    $[1] = time;
    $[2] = t7;
    $[3] = t8;
  } else {
    t7 = $[2];
    t8 = $[3];
  }
  useEffect(t7, t8);
  const t = useTranslations("timer");
  const t9 = `flex items-center gap-2 ${textPosition === "left" ? "md:flex-row" : "md:flex-row-reverse"} ${textMobilePosition === "bottom" ? "flex-col-reverse" : "flex-col"} ${className}`;
  let t10;
  if ($[4] !== text || $[5] !== withoutMd) {
    t10 = text && <div className={`font-['Inter'] whitespace-pre text-left font-semibold text-[#FFFFFF] ${!withoutMd ? "text-xs md:text-base" : "text-sm md:text-input"}`}><p className="m-0 leading-[1.15]">{text}</p></div>;
    $[4] = text;
    $[5] = withoutMd;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  const t11 = `flex items-center gap-0.5 ${!withoutMd ? "md:w-[220px]" : "w-[220px]"}`;
  const t12 = showDays && `${!withoutMd ? "md:w-fit" : "w-fit"}`;
  let t13;
  if ($[7] !== t11 || $[8] !== t12) {
    t13 = cn(t11, t12);
    $[7] = t11;
    $[8] = t12;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== showDays || $[11] !== t || $[12] !== timeLeft.days || $[13] !== variant || $[14] !== withoutMd) {
    t14 = showDays && <>{variant === "alternative" ? <TimerDigitSecond value={timeLeft.days} /> : <TimerDigit value={timeLeft.days} withoutMd={withoutMd} />}<span className={`font-['Inter'] font-medium text-[#e9ecf0] ${!withoutMd ? "text-[16px] md:text-[24px]" : "text-[24px]"}`}>{t("days", {
          count: timeLeft.days
        })}</span></>;
    $[10] = showDays;
    $[11] = t;
    $[12] = timeLeft.days;
    $[13] = variant;
    $[14] = withoutMd;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== timeLeft.hours || $[17] !== variant || $[18] !== withoutMd) {
    t15 = variant === "alternative" ? <TimerDigitSecond value={timeLeft.hours} /> : <TimerDigit value={timeLeft.hours} withoutMd={withoutMd} />;
    $[16] = timeLeft.hours;
    $[17] = variant;
    $[18] = withoutMd;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== withoutMd) {
    t16 = <TimerSeparator withoutMd={withoutMd} />;
    $[20] = withoutMd;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== timeLeft.minutes || $[23] !== variant || $[24] !== withoutMd) {
    t17 = variant === "alternative" ? <TimerDigitSecond value={timeLeft.minutes} /> : <TimerDigit value={timeLeft.minutes} withoutMd={withoutMd} />;
    $[22] = timeLeft.minutes;
    $[23] = variant;
    $[24] = withoutMd;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== withoutMd) {
    t18 = <TimerSeparator withoutMd={withoutMd} />;
    $[26] = withoutMd;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== timeLeft.seconds || $[29] !== variant || $[30] !== withoutMd) {
    t19 = variant === "alternative" ? <TimerDigitSecond value={timeLeft.seconds} /> : <TimerDigit value={timeLeft.seconds} withoutMd={withoutMd} />;
    $[28] = timeLeft.seconds;
    $[29] = variant;
    $[30] = withoutMd;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t13 || $[33] !== t14 || $[34] !== t15 || $[35] !== t16 || $[36] !== t17 || $[37] !== t18 || $[38] !== t19) {
    t20 = <div className={t13}>{t14}{t15}{t16}{t17}{t18}{t19}</div>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t10 || $[41] !== t20 || $[42] !== t9) {
    t21 = <div className={t9}>{t10}{t20}</div>;
    $[40] = t10;
    $[41] = t20;
    $[42] = t9;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  return t21;
};